<template>
  <div class="container">
    <div class="d-flex flex-column text-left border">
      <div class="d-flex flex-fill border-bottom p-2">
        <span>到貨作業</span>
      </div>
      <div v-if="excelHis" class="d-flex flex-column border-bottom p-2">
        <span>您最近建立過報表之搜尋紀錄（前5筆）</span>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th></th>
              <th>品項</th>
              <th>出貨方式</th>
              <th>付款狀態</th>
              <th>日期</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td><a href="#" @click.prevent="">絕對考上導遊＋領隊有聲書（九版）</a></td>
              <td>郵局寄送</td>
              <td>已付款</td>
              <td>2020-04-06~2020-05-10</td>
              <td><a href="#" @click.prevent="">查詢</a></td>
            </tr>
            <tr>
              <td>2</td>
              <td><a href="#" @click.prevent="">絕對考上導遊＋領隊有聲書（八版）</a></td>
              <td>線上領取</td>
              <td>已付款</td>
              <td>2020-04-06~2020-05-10</td>
              <td><a href="#" @click.prevent="">查詢</a></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex border-bottom">
        <div class="arrivalTitle border-right p-2">快速篩選</div>
        <div class="d-flex flex-column p-2">
          <div class="d-flex align-items-center">
            <span>商品搜尋</span>
            <div>
              <b-form-input></b-form-input>
            </div>
            <div><button type="button" class="btn btn-primary">查詢商品F8</button></div>
          </div>
          <div class="d-flex align-items-center">
            <span>出貨方式</span>
            <div>
              <select class="form-control">
                <option>全部方式</option>
                <option>現場領取</option>
                <option>郵局寄送</option>
                <option>超商取貨</option>
              </select>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <span>依付款日</span>
            <div>
              <select class="form-control">
                <option>三個月前</option>
              </select>
            </div>
            <div>
              <select class="form-control">
                <option>所有付款狀態</option>
                <option>未付款</option>
                <option>完款</option>
                <option>特殊狀態</option>
              </select>
            </div>
          </div>
          <div class="d-flex align-items-center ml-5 pl-3">
            <div>
              <button type="button" class="btn btn-primary">開始搜尋</button>
            </div>
            <small>／／先完款先出貨篩選，特殊狀態需另外篩選</small>
          </div>
        </div>
      </div>
      <div class="d-flex border-bottom">
        <b-nav>
          <b-nav-item :active="tab === 1" @click="tab = 1" class="arrNav"
            :class="{active:tab === 1}">全部</b-nav-item>
          <b-nav-item :active="tab === 2" @click="tab = 2" class="arrNav"
            :class="{active:tab === 2}">已排出貨</b-nav-item>
          <b-nav-item :active="tab === 3" @click="tab = 3" class="arrNav"
            :class="{active:tab === 3}">未排出貨</b-nav-item>
          <b-nav-item :active="tab === 4" @click="tab = 4" class="arrNav"
            :class="{active:tab === 4}">進階篩選</b-nav-item>
          <b-nav-item :active="tab === 5" @click="tab = 5" class="arrNav"
            :class="{active:tab === 5}">相關商品</b-nav-item>
        </b-nav>
        <!-- <b-nav class="nav-tabs">
  <b-nav-item v-bind:active="tab === 1" v-on:click="tab = 1">Link 1</b-nav-item>
  <b-nav-item v-bind:active="tab === 2" v-on:click="tab = 2">Link 2</b-nav-item>
  <b-nav-item v-bind:active="tab === 3" v-on:click="tab = 3">Link 3</b-nav-item>
</b-nav> -->
      </div>
      <div class="d-flex flex-column p-2">
        <div class="d-flex justify-content-between">
          <span>總共 180 筆訂單（搜尋時間：0.1秒，依<u>付款日升序</u>）</span>
          <small>2020/01/09~2020/04/09</small>
        </div>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="9">
                <div class="d-flex align-items-center">
                  <span>欄位預設項目</span>
                  <u class="ml-3" v-if="!startEdit">郵局寄送</u>
                  <div class="ml-3" v-else-if="startEdit">
                    <select class="form-control">
                      <option>全部方式</option>
                      <option>現場領取</option>
                      <option>郵局寄送</option>
                      <option>超商取貨</option>
                    </select>
                  </div>
                  <span class="ml-3" v-if="!startEdit">2020/08/08, 全天</span>
                  <div v-else-if="startEdit">
                    <b-form-datepicker class="ml-3"></b-form-datepicker>
                  </div>
                  <div class="ml-3">
                    <button type="button" class="btn btn-primary"
                      @click="startEdit = true">編輯</button>
                  </div>
                  <div v-if="startEdit" class="ml-3">
                    <button type="button" class="btn btn-primary"
                      @click="startEdit = false">完成</button>
                  </div>
                </div>
              </th>
            </tr>
            <tr>
              <th></th>
              <th>商品</th>
              <th>數量</th>
              <th>狀態</th>
              <th>出貨方式</th>
              <th>其他待出貨品</th>
              <th>訂購人</th>
              <th>訂單備註</th>
              <th>訂單明細</th>
            </tr>
          </thead>
          <tbody>
            <tr class="shipList" v-for="(item, index) in on_ship_list" :key="index">
              <td>
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{index + 1}}</div>
                  <div><button type="button" class="btn btn-sm btn-outline-secondary"
                      v-b-modal.shipConfirm>出貨</button>
                  </div>
                </div>
              </td>
              <td>{{item.ship_title}}</td>
              <td>{{item.ship_count}}</td>
              <td>{{item.ship_status}}</td>
              <td>{{item.ship_moehod}}</td>
              <td></td>
              <td>
                <div class="d-flex flex-column">
                  <span>{{item.ship_purchaser}}</span>
                  <span>{{item.ship_phone}}</span>
                </div>
              </td>
              <td>{{item.ship_remark}}</td>
              <td>
                <div class="d-flex flex-column">
                  <span>{{item.ship_order_date}}</span>
                  <span>{{item.ship_uid}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2">總訂購量</td>
              <td>80件</td>
              <td colspan="6"></td>
            </tr>
            <tr>
              <td colspan="2">訂單已排出貨2筆，合計</td>
              <td>2件</td>
              <td>庫存量</td>
              <td colspan="5">
                <div class="d-flex justify-content-between align-items-center">
                  <span>10件（+預進40件）</span>
                  <div>
                    <button type="button" class="btn btn-outline-warning"
                      @click="excelHis = true">建立報表並匯出EXCEL</button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-modal id="shipConfirm" title="出貨確認" ok-title="出貨" cancel-title="取消" size="xl">
      <div class="d-flex flex-column">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td align="right">出貨設定</td>
              <td>
                <div class="d-flex align-items-center">
                  <u class="ml-3">郵局寄送</u>
                  <span v-if="!startEdit2" class="ml-3">2020/08/08, 全天</span>
                  <div v-else-if="startEdit2">
                    <b-form-datepicker class="ml-3"></b-form-datepicker>
                  </div>
                  <div class="ml-3">
                    <button type="button" class="btn btn-primary"
                      @click="startEdit2 = true">另擇日期</button>
                  </div>
                  <div v-if="startEdit2" class="ml-3">
                    <button type="button" class="btn btn-primary"
                      @click="startEdit2 = false">完成</button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td align="right">品項</td>
              <td>絕對考上導遊＋領隊 有聲書（九版）</td>
            </tr>
            <tr>
              <td align="right">
                <div class="d-flex flex-column">
                  <span>收貨資訊</span>
                  <small>（與訂購人不同）</small>
                </div>
              </td>
              <td>
                <div class="d-flex justify-content-around">
                  <div class="d-flex flex-column">
                    <span>收件人</span>
                    <span>收件地址</span>
                  </div>
                  <div class="d-flex flex-column">
                    <span>BBB</span>
                    <span>235新北市中和區</span>
                  </div>
                  <div class="d-flex flex-column">
                    <span>聯絡電話</span>
                    <span>郵局</span>
                  </div>
                  <div class="d-flex flex-column">
                    <span>0987654321</span>
                    <span>ＯＯＯＯＯＯＯ</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: 1,
      startEdit: false,
      startEdit2: false,
      excelHis: false,
    };
  },
  computed: {
    on_ship_list: {
      get() {
        return this.$store.state.ship.on_ship_list;
      },
    },
  },
};

</script>

<style lang="scss">
  .arrivalTitle {
    writing-mode: vertical-lr;
    width: 40px;
  }

  .arrNav {
    &.active {
      border-bottom: 5px solid blue;
    }
  }

  .shipList {
    &:hover {
      background-color: aquamarine;
    }
  }

</style>
